export enum StationStatus {
	Pending = 'pending',
	Editing = 'editing',
	ApprovalPending = 'approval-pending',
	Open = 'open',
	Close = 'close',
	Inactive = 'inactive',
	LastYear = 'last-year',
};